import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { ColumnGroup, Column, MyMazdaSummary, SpecificationList } from "containers"
import { Heading } from "components"
import MyMazdaHeader from "./mymazda-header"

const MyMazdaSpecificationBlock = (props) => {
  /**
   * @param {String} heading - Heading text.
   * @param {Object} vehicleProps - Vehicle properties.
   * @param {Object|BackHyperlink} backButton - props for back button
   * @param {Object} specifications - Specifications data object.
   * @returns {ReactElement} React Component
   */
  const {
    specifications, Interactive = "", heading = "", vehicleProps, backButton, logo
  } = props
  if (props.error) {
    return <div style={{ color: "red", textAlign: "center" }}>{props.error}</div>
  }
  return (
    <div>
      <MyMazdaHeader backButton={backButton} logo={logo} />
      <ColumnGroup maxWidth={800}>
        <Column textAlignMobile="center" textAlign="center">
          <Heading tag="h3" margin value={heading.replace("{nameplate}", vehicleProps.nameplate)} />
          <img src={vehicleProps.imageSrc} alt={heading} style={{ maxWidth: "100%" }} />
          <MyMazdaSummary
            {...vehicleProps}
            heading={Interactive.replace("{nameplate}", vehicleProps.nameplate)} />
          {specifications && <SpecificationList specs={specifications.data.categories} />}
        </Column>
      </ColumnGroup>
    </div>
  )
}

MyMazdaSpecificationBlock.propTypes = {
  error: PropTypes.string,
  Interactive: PropTypes.string,
  heading: PropTypes.string,
  vehicleProps: PropTypes.object,
  logo: PropTypes.string,
  backButton: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    logo: PropTypes.string
  }),
  specifications: PropTypes.shape({
    data: PropTypes.shape({
      categories: PropTypes.array,
      disclaimers: PropTypes.array
    })
  })
}

export default Radium(MyMazdaSpecificationBlock)

/**
 * @typedef {Object} BackHyperlink
 * @property {String} name - Displayed Name.
 * @property {String} href - Hyperlink href.
 */



// WEBPACK FOOTER //
// ./src/containers/mymazda-specifications-block/index.jsx